import React from 'react'

import AllSections from '../Home/AllSections'

export default function AboutUs() {
  return (
    <div className=''>

   {/* Banner Section */}
   <div className='md:h-[80vh] h-[60vh] relative'>
          <h2 className='bg-transparent pt-72 z-30 absolute text-white md:pl-48 md:text-8xl text-5xl'>
            About
          </h2>
          <div className='md:h-[80vh] h-[60vh] bg-black opacity-50 w-full absolute z-20'></div>
          <img
            src='https://images.pexels.com/photos/3856440/pexels-photo-3856440.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
            alt='Contact Us Banner'
            className='h-full w-full object-cover'
          />
        </div>
      {/* <h1 className='text-5xl uppercase md:pl-28 pl-4'> About Us </h1> */}
      <div className=' gap-10 px-12 md:pl-32 pt-12 flex flex-col md:flex-row'>
<p className='text-lg text-left '>
      <span className='text-3xl block'>Welcome,</span> <span className='md:pl-36'>to</span> <span className='uppercase font-bold underline opacity-95 text-green-500'>South Global Exim</span><span className='opacity-60 text-xl'>
      , your trusted partner in the world of spices and natural products. At Arundhati Exim, we take pride in offering a diverse range of high-quality spice blends and powders, dried chili varieties, seeds, pods, berries, bark, and wholesome jaggery. Our commitment to excellence, authenticity, and sustainability sets us apart as a reliable source for all your spice and natural product needs.
      </span>
</p>

<img src='https://images.pexels.com/photos/3531700/pexels-photo-3531700.jpeg' alt='' className='md:w-[40%] rounded-xl shadow-2xl'/> 
      </div>
<AllSections/>
     
    </div>
  )
}
